<template>
    <div class="storeList">
        <status-tabs
            :status.sync="status"
            :statusList="statusList"
            :funcName="funcName"
        ></status-tabs>

        <search-tool
            ref="searchTool"
            :status="status"
            :statusList="statusList"
            :funcName="funcName"
            :searchForm="searchForm"
            :searchList="searchList"
            :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields"
            listName="shop"
            :loading="loading"
            :menuAuth="menuAuth"
            :showRefresh="false"
            :inputPlaceholder="inputPlaceholder"
            :selected="selectList.length"
        ></search-tool>

        <div
            :class="`table${
                (hasSearchCondition && ' has-search-condition') || ''
            }`"
        >
            <el-table
                :data="tableData"
                highlight-current-row
                height="100%"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection"
                    align="center"
                    :fixed="checkFixed"
                ></el-table-column>
                <el-table-column
                    width="80"
                    align="left"
                    label="ID"
                    prop="id"
                ></el-table-column>
                <el-table-column
                    label="Name"
                    property="name"
                    align="left"
                    min-width="250"
                >
                    <template slot-scope="scope">
                        <div class="tableTitleCont">
                            <div class="topTitle">
                                <a
                                    :href="
                                        scope.row.http_type + scope.row.shop_url
                                    "
                                    v-if="
                                        scope.row.http_type &&
                                        scope.row.shop_url
                                    "
                                    target="_blank"
                                    >{{ scope.row.name }}</a
                                >
                                <p v-else>
                                    <span>{{ scope.row.name }}</span>
                                    <span
                                        class="row_username"
                                        v-if="scope.row.user_name"
                                        >({{ scope.row.user_name }})</span
                                    >
                                </p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    :label="$t('storeList.tableName.platform_id')"
                    property="platform_name"
                    align="left"
                ></el-table-column>
                <el-table-column
                    label="Sync Order"
                    align="left"
                >
                    <template slot-scope="scoped">
                        <i
                            class="col-customized"
                            :class="[
                                scoped.row.sync_order == 1
                                    ? 'el-icon-circle-check check'
                                    : 'el-icon-circle-close',
                            ]"
                        ></i>
                    </template>
                </el-table-column>
                <el-table-column
                    label="App Type"
                    property="auth_type"
                    align="left"
                >
                    <template slot-scope="scoped">
                        <span v-if="scoped.row.auth_type == 1">Private</span>
                        <span v-else-if="scoped.row.auth_type == 2">Custom</span>
                        <span v-else>App</span>
                    </template>
                </el-table-column>

                <el-table-column
                    label="Store Url"
                    property="shop_url"
                    align="left"
                    width="80"
                >
                    <template slot-scope="scoped">
                        <a :href="scoped.row.shop_url" target="_blank" v-if="scoped.row.shop_url" >
                            <i class="col-customized el-icon-link check"></i>
                        </a>
                    </template>
                </el-table-column>
                
                <el-table-column
                    label="Customized Field"
                    property="customized"
                    align="center"
                >
                    <template slot-scope="scoped">
                        <i
                            class="col-customized"
                            :class="[
                                scoped.row.customized == 1
                                    ? 'el-icon-circle-check check'
                                    : 'el-icon-circle-close',
                            ]"
                        ></i>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Authorized"
                    align="center"
                    min-width="100"
                >
                    <template slot-scope="scope">
                        <span
                            class="general-table-tag"
                            :class="[
                                scope.row.authed == 1 ? 'success' : 'info',
                            ]"
                        >
                            <i class="el-icon-s-help"></i>
                            {{
                                scope.row.authed == 1
                                    ? $t("storeList.tableName.authed_success")
                                    : $t("storeList.tableName.authed_danger")
                            }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                    :label="$t('storeList.tableName.create_at')"
                    property="created_at"
                    align="center"
                    width="150"
                ></el-table-column>
                <el-table-column
                    :label="$t('storeList.tableName.operation')"
                    align="left"
                    width="150"
                    :fixed="operationFixed"
                >
                    <template slot-scope="scope">
                        <operation :scope="scope" @rowDo="rowDo"></operation>
                    </template>
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg" />
                </el-empty>
            </el-table>
        </div>

        <pagination
            :paginationData="paginationData"
            @paginationChange="paginationChange"
            :funcName="funcName"
        ></pagination>

        <add :addVisible.sync="addVisible"></add>
        <edit
            :editVisible.sync="editVisible"
            :tableItem.sync="tableItem"
        ></edit>
        <detail
            :detailVisible.sync="detailVisible"
            :tableItem.sync="tableItem"
        ></detail>
        <auth
            :authVisible.sync="authVisible"
            :tableItem.sync="tableItem"
            :authKeyList.sync="authKeyList"
            @shopName="shopName"
            @shopId="shopId"
        ></auth>
        <importPublic
            :importVisible.sync="importVisible"
            :parentFuncName="'shop'"
            :methodName="'shopImport'"
            :temSrc="'/v1/shop/download-tpl'"
            :title="
                $i18n.locale == 'zh' ? '店铺列表导入' : 'Import shop`s data'
            "
        ></importPublic>
        <stores :platformList="platformList" :showDialog.sync="showPlatform"></stores>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
import add from "./storeList/add";
import edit from "./storeList/edit";
import detail from "./storeList/detail";
import auth from "./storeList/auth";
import importPublic from "@/common/components/importPublic";
import search_compound from "@/common/components/search/search_compound";
import stores from "@/common/components/stores-modal.vue";
export default {
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            inputPlaceholder: "Keywords include Name、Email",
            searchForm: {
                keyword: "",
                status: "",
                name: "",
                track_id: "",
                platform_id: "",
                authed: "",
                customized: "",
            },
            searchForm_transfer: {
                status: "",
                track_id: "",
                authed: "",
                customized: "",
                platform_id: "",
            },
            authVisible: false,
            authKeyList: [],
            addVisible: false,
            editVisible: false,
            detailVisible: false,
            importVisible: false,
            funcName: "shop",
            selectList: [],
            countryList: [],
            shop_name: "",
            shop_id: "",
            platformList: [],
            showPlatform: false,
            advanceSearchFields: {
                status: {
                    label: "Status",
                    type: "select",
                    options: [],
                },
                authed: {
                    label: "Authed",
                    type: "select",
                    options: [
                        {
                            label: "Unauthorized",
                            value: 0,
                        },
                        {
                            label: "Authorized",
                            value: 1,
                        },
                    ],
                },
                customized: {
                    label: "Customized",
                    type: "select",
                    options: [
                        {
                            label: "No",
                            value: 0,
                        },
                        {
                            label: "Yes",
                            value: 1,
                        },
                    ],
                },
                platform_id: {
                    label: "Platform",
                    type: "select",
                    options: [],
                },
            },
        };
    },
    methods: {
        add() {
            this.showPlatform = true
        },
        handleSelectionChange(val) {
            this.selectList = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
            }
        },
        clean() {
            this.searchForm = {
                name: "",
                status: "",
                track_id: "",
                customer_ids: [],
                country_id: [],
                platform_id: '',
            };
            this.searchForm_transfer = {
                status: "",
                track_id: "",
                customer_ids: [],
                country_id: [],
                platform_id: "",
            };
        },
        /**
         * 获取商店table
         */
        shop(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi
                .shop(
                    {
                        platform: this.platform_id,
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                        status: this.status,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.menuAuth = res.ext.op_auth;
                        this.paginationData.total = res.total;
                        this.statusList = res.ext.tabs;
                        this.searchList[1].props.list = this.advanceSearchFields.status.options =
                            res.ext.tabs.map((item) => {
                                return { label: item.name, value: item.status };
                            });
                        this.closeDrawer();
                        this.loading = false;
                    }
                });
        },
        toUrl(url){
            window.open(url, '_blank');
        },
        /**
         * table内权限按钮
         */
        rowDo(item, row) {
            if (item.status_flag == 1) {
                if (item.funcName == "edit") {
                    this.editVisible = true;
                    this.tableItem = row;
                } else if (item.funcName == "detail") {
                    this.detailVisible = true;
                    this.tableItem = row;
                } else if (item.funcName == "auth") {
                    this.authVisible = true;
                    this.tableItem = row;
                    if (row.platform_id == 3) {
                        this.authKeyList = [
                            { key: "appid", name: "AppId" },
                            { key: "secret", name: "Secret" },
                            { key: "access_token", name: "Access Token" },
                            { key: "shop", name: "Shop" },
                        ];
                    } else if (row.platform_id == 4) {
                        this.authKeyList = [
                            { key: "shop", name: "Shop" },
                        ];
                    } else if (row.platform_id == 6){
                        this.authKeyList = [
                            { key: "AppKey", name: "Appkey" },
                            { key: "AppSecret", name: "Appsecret" },
                            { key: "access_token", name: "Access Token" },
                        ];
                    }else if (row.platform_id == 8) {
                        this.authKeyList = [
                            { key: "shop", name: "Shop" },
                        ];
                    } 
                }
            } else if (item.status_flag == 2) {
                this.$prompt(`Do you want to continue?`, "Tip", {
                    inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                    inputErrorMessage: `Please enter ${item.name}Reason`,
                    inputPlaceholder: `${item.name}Reason`,
                })
                    .then(({ value }) => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                                reason: value,
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 3) {
                this.$confirm(`Do you want to continue?`, "Tip", {
                    type: "warning",
                })
                    .then(() => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 4) {
                if (item.funcName == "delete") {
                    cmofferApi[item.parent_funcname]({}, "delete", row.id).then(
                        (res) => {
                            if (res) {
                                this.$message.success(`${item.name} Success`);
                                this[item.parent_funcname]();
                            }
                        }
                    );
                }
            }
        },
        /**
         * 菜单选择
         */
        handleSelect(val) {
            this.searchForm = {
                name: "",
                status: "",
            };
            this.platform_id = val;
            this.shop();
        },
        shopName(val) {
            this.shop_name = val;
        },
        shopId(val) {
            this.shop_id = val;
        },
        /**
         * 平台下拉列表获取
         */
        platformSelect() {
            cmofferApi.platformSelect({}, "get").then((res) => {
                console.log(res)
                if (res) {
                    this.platformList = res.data;
                    this.advanceSearchFields.platform_id.options = this.searchList[4].props.list = this.platformList.map(item=>{
                        return {
                            label: item.name,
                            value: item.id.toString()
                        }
                    });
                }
            });
        },
        authFunc(funcName) {
            this[funcName]();
        },
        import() {
            this.importVisible = true;
        },
        searchTags(params) {
            this.searchForm[params.key] = params.value;
        },
        shop_transfer() {
            this.searchForm = Object.assign(
                this.searchForm,
                this.searchForm_transfer
            );
            this.shop();
        },
        async initialize() {
            await this.shop();
            await this.platformSelect();
            // await this.countrySelect();
        },
    },
    activated() {
        this.initialize();
    },
    components: {
        add: add,
        edit: edit,
        detail: detail,
        auth: auth,
        importPublic: importPublic,
        search_compound: search_compound,
        stores,
    },
    computed: {
        searchList() {
            return [
                {
                    label: this.$i18n.locale == "zh" ? "关键字" : "Keyword",
                    key: "keyword",
                    type: "input",
                },
                {
                    label: this.$i18n.locale == "zh" ? "状态" : "Status",
                    key: "status",
                    type: "select",
                    props: {
                        list: [],
                        nameKey: "keyword",
                        valueKey: "status",
                    },
                },
                {
                    label: this.$i18n.locale == "zh" ? "授权" : "Authed",
                    key: "authed",
                    type: "select",
                    props: {
                        list: [
                            {
                                label: "Unauthorized",
                                value: 0,
                            },
                            {
                                label: "Authorized",
                                value: 1,
                            },
                        ],
                        nameKey: "keyword",
                        valueKey: "authed",
                    },
                },
                {
                    label: this.$i18n.locale == "zh" ? "定制" : "Customized",
                    key: "customized",
                    type: "select",
                    props: {
                        list: [
                            {
                                label: "No",
                                value: 0,
                            },
                            {
                                label: "Yes",
                                value: 1,
                            },
                        ],
                        nameKey: "keyword",
                        valueKey: "customized",
                    },
                },
                {
                    label: this.$i18n.locale == "zh" ? "平台" : "Platform",
                    key: "platform_id",
                    type: "select",
                    props: {
                        list: [],
                        nameKey: "keyword",
                        valueKey: "platform_id",
                    },
                },
            ];
        },
    },
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (!!v) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }

                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.storeList {
    width: 100%;
    height: 100%;
    background: #fff;
    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;

        height: calc(100% - 160px);
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        &.has-search-condition {
            height: calc(100% - 192px);
        }
        .row_username {
            margin-left: 5px;
            color: $color-danger;
        }
        .col-customized {
            font-size: 18px;
            &.check {
                color: $color-primary;
            }
        }
        a {
            text-decoration: none;
            outline: none;
        }
    }
}
</style>
